import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import PaymentForm from "./PaymentForm";

export default function PaymentPage() {
  const [searchParams] = useSearchParams();

  const [jwtToken, setJwtToken] = useState(null);
  const [amount, setAmount] = useState(0);
  const [amountWithoutCharge, setAmountWithoutCharge] = useState(null);
  const [event, setEvent] = useState(null);
  const [paymentIntentId, setPaymentIntentId] = useState(null);
  const [currency, setCurrency] = useState('gbp');

  useEffect(() => {
    setAmount(searchParams.get("amount"));
    setAmountWithoutCharge(searchParams.get("amountWithoutCharge"));
    setJwtToken(searchParams.get("jwtToken"));
    setEvent(searchParams.get("event"));
    setPaymentIntentId(searchParams.get("paymentIntentId"));
    setCurrency(searchParams.get("currency"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (
    !jwtToken ||
    Number(amount) === 0 ||
    isNaN(Number(amount)) ||
    !event ||
    !paymentIntentId ||
    !currency
  ) {
    return <></>;
  }

  return (
    <PaymentForm
      payload={{
        event,
        jwtToken,
        amount: amount,
        amountWithoutCharge: amountWithoutCharge,
        paymentIntentId,
        currency,
      }}
    />
  );
}